import { createSwipersBig, createSwipersThumb } from "./../product.js";

export const taille_carre = (el) => {
  import(
    /* webpackChunkName: "dialog" */
    "./../dialog.js"
  ).then((dialogImport) => {
    var id_attribute = el.data("taille");
    if (el.hasClass("opacity_40") == true) {
      let options = {
        type: "success",
        title: "Etre prévenu(e) en cas d'ajout de stock",
        message: "Votre email :",
        timeout: 50000,
        id: "inputs",
        inputs: [
          [
            '<input type="text">',
            "keyup",
            function (instance, toast, input, e) {
              console.info(input.value);
            },
            true,
          ],
        ],
        buttons: [
          [
            "<button><b>Confirmer</b></button>",
            function (instance, toast, button, e, inputs) {
              var email = inputs[0].value;
              $.ajax({
                type: "POST",
                url: "/",
                async: true,
                cache: false,
                dataType: "json",
                data: {
                  controller: "cart",
                  action: "emailRemind",
                  email: email,
                  ajax: true,
                  id_product: $("#product_page_product_id").val(),
                  ipa: id_attribute,
                  token: prestashop.static_token,
                },
                success: function (jsonData, textStatus, jqXHR) {
                  if (jsonData.email_valide !== true) {
                    dialogImport.dialog({
                      type: "error",
                      title: "Problème",
                      message: "Votre email n'est pas valide.",
                    });
                  } else {
                    dialogImport.dialog({
                      type: "success",
                      title: "Demande prise en compte",
                      message:
                        "Vous recevrez un email dès lors que cette taille sera disponible.",
                    });
                  }
                },
              });

              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            false,
          ], // true to focus
        ],
      };
      dialogImport.dialog(options);

      return;
    }

    console.log('click taille_carre', el);
    console.log('taille_choisie', el.data("taille"));
    el.closest('.product-variants-item').find('.taille_carre')
      .removeClass("charte_btn charte_contour_fonce")
      .addClass("fond_blanc contour_gris");
    el.removeClass("contour_gris").addClass("charte_contour_fonce");
    el.removeClass("fond_blanc").addClass("charte_btn");

    dialogImport.dialog({
      type: "success",
      title: "Taille choisie.",
      message:
        "Vous pouvez maintenant cliquer sur « <b>Ajouter au panier</b> » pour le commander.",
      backgroundColor: "#222222",
    });

    $(".taille_choisie").attr("data-taille", parseInt(el.data("taille")));
    $(".product-variants input").val(parseInt(el.data("group-value")));
  });
};

export const pack_taille_carre = (el) => {
  console.log('pack_taille_carre');
  import(
    /* webpackChunkName: "dialog" */
    "./../dialog.js"
  ).then((dialogImport) => {
    var id_attribute = el.data("taille");
    if (el.hasClass("opacity_40") == true) {
      let options = {
        type: "success",
        title: "Etre prévenu(e) en cas d'ajout de stock",
        message: "Votre email :",
        timeout: 50000,
        id: "inputs",
        inputs: [
          [
            '<input type="text">',
            "keyup",
            function (instance, toast, input, e) {
              console.info(input.value);
            },
            true,
          ],
        ],
        buttons: [
          [
            "<button><b>Confirmer</b></button>",
            function (instance, toast, button, e, inputs) {
              var email = inputs[0].value;
              $.ajax({
                type: "POST",
                url: "/",
                async: true,
                cache: false,
                dataType: "json",
                data: {
                  controller: "cart",
                  action: "emailRemind",
                  email: email,
                  ajax: true,
                  id_product: $("#product_page_product_id").val(),
                  ipa: id_attribute,
                  token: prestashop.static_token,
                },
                success: function (jsonData, textStatus, jqXHR) {
                  if (jsonData.email_valide !== true) {
                    dialogImport.dialog({
                      type: "error",
                      title: "Problème",
                      message: "Votre email n'est pas valide.",
                    });
                  } else {
                    dialogImport.dialog({
                      type: "success",
                      title: "Demande prise en compte",
                      message:
                        "Vous recevrez un email dès lors que cette taille sera disponible.",
                    });
                  }
                },
              });

              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            false,
          ], // true to focus
        ],
      };
      dialogImport.dialog(options);

      return;
    }
    el.closest('.product-variants-item').find('.taille_carre')
      .removeClass("charte_btn charte_contour_fonce")
      .addClass("fond_blanc contour_gris");
    el.removeClass("contour_gris").addClass("charte_contour_fonce");
    el.removeClass("fond_blanc").addClass("charte_btn");

    /*dialogImport.dialog({
      type: "success",
      title: "Taille choisie.",
      message:
        "Vous pouvez maintenant cliquer sur « <b>Ajouter au panier</b> » pour le commander.",
      backgroundColor: "#222222",
    });*/

    el.closest('.product-variants-item').find('.taille_choisie').attr("data-taille", parseInt(el.data("taille")));
    //$(".product-variants input").val(parseInt(el.data("group-value")));
    updatePackTable();
    //swiper.init();
    //console.log(swiper);
  });
};


export function tailleCarreBtn() {

  $('#product-information').on("click", ".taille_carre", function (event) {
    console.log('click depart taille');
    event.preventDefault();
    if ($('#ap5-buy-block-container').length > 0) {
      console.log('ap5-buy-block-container exist');
      const end = pack_taille_carre($(this));

      setTimeout(function () {
        createSwipersBig();
        createSwipersThumb();
      }, 2000);
    }
    else {
      taille_carre($(this));
    }
  });
}

// Send ajax query in order to update pack table
export function updatePackTable() {
  $('.add-to-cart').attr('disabled', true);
  ap5Plugin.log('[ap5Plugin.updatePackTable] Call');
  const productPackChoice = [];
  const productPackQuantityList = [];
  // FOREACH EACH SIZES BLOCK OF PRODUCTS OF PACK
  $('.ap5-attributes').each(function (index, element) {

    const id_product_pack = $(this).attr('data-id-product-pack');
    const productChoice = { idProductPack: id_product_pack, attributesList: [] };
    /* $('select, input[type=hidden], input[type=radio]:checked', $(element)).each(function () {
                                          productChoice.attributesList.push(parseInt($(this).val()));
                                        }); */
    const taille = $(this).find('.taille_choisie').attr('data-taille');
    console.log('updatePackTable taille', taille, $(this).find('.taille_choisie'));
    console.log('updatePackTable element', element);
    productChoice.attributesList.push(parseInt(taille));
    productPackChoice.push(productChoice);
  });

  // Get quantity for each product
  $('.ap5-quantity-wanted').each(function (index, element) {
    id_product_pack = $(this).attr('data-id-product-pack');
    productPackQuantity = { idProductPack: id_product_pack, quantity: 1 };
    productPackQuantityList.push(productPackQuantity);
  });

  const pmAjaxSpinnerInstance = ap5Plugin.addLayerLoading($('#ap5-product-list'));

  console.log('productPackChoice', productPackChoice);
  //return false;
  $.ajax({
    type: 'POST',
    url: ap5_updatePackURL,
    data: {
      productPackChoice,
      productPackExclude: ap5Plugin.productPackExclude,
      productPackQuantityList,
      fromQuickView: (typeof (ap5Plugin.fromQuickView) !== 'undefined' && ap5Plugin.fromQuickView ? 1 : 0),
      token: prestashop.static_token,
    },
    dataType: 'json',
    cache: false,
    success(jsonData, textStatus, jqXHR) {
      console.log('ajax success');
      $(document).trigger('ap5-Before-UpdatePackContent');
      if (typeof (jsonData.hasError) !== 'undefined' && jsonData.hasError) {
        ap5Plugin.displayErrors(jsonData);
        // Restore exclusion
        ap5Plugin.productPackExclude = ap5Plugin.productPackExcludeBackup.slice(0);
      } else {
        console.log('ajax update html');
        if (typeof (jsonData.packContentTable) !== 'undefined') {
          $('#ap5-product-list').replaceWith(jsonData.packContentTable);
        }
        if (typeof (jsonData.packPriceContainer) !== 'undefined') {
          $('#ap5-buy-block-container').replaceWith(jsonData.packPriceContainer);
          //tailleCarreBtn();

        }
        if (typeof (jsonData.HOOK_EXTRA_RIGHT) !== 'undefined') {
          $('#ap5-hook-product-extra-right-container').html(jsonData.HOOK_EXTRA_RIGHT);
        }
        if (typeof (jsonData.productPackExclude) !== 'undefined') {
          ap5Plugin.productPackExclude = jsonData.productPackExclude;
        }
        if ((typeof (jsonData.packHasFatalErrors) !== 'undefined' && jsonData.packHasFatalErrors === true)
          || (typeof (jsonData.packHasErrors) !== 'undefined' && jsonData.packHasErrors === true)
          || (typeof (jsonData.packAvailableQuantity) !== 'undefined' && jsonData.packAvailableQuantity <= 0)
        ) {
          $('#ap5-add-to-cart').hide();
        } else {
          $('#idCombination').val(jsonData.packAttributesList);
          $('#ap5-add-to-cart').show();
        }
      }
      setTimeout(() => {
        ap5Plugin.initNewContent(jsonData);
        ap5Plugin.removeLayerLoading(pmAjaxSpinnerInstance);
        $(document).trigger('ap5-After-UpdatePackContent');
      }, 100);
    },
    error(XMLHttpRequest, textStatus, errorThrown) {
      $('#ap5-add-to-cart').hide();
      alert(`Impossible to update pack attribute choice.\n\ntextStatus: '${textStatus}'\nerrorThrown: '${errorThrown}'\nresponseText:\n${XMLHttpRequest.responseText}`);
    },
    complete(jqXHR, textStatus) {
      ap5Plugin.removeLayerLoading(pmAjaxSpinnerInstance);
      $('.add-to-cart').attr('disabled', false);

    },
  });
};
